// extracted by mini-css-extract-plugin
export default {"tooltip":"mV-z","arrow":"nV-z"};